import { Modal, Group, Text } from '@mantine/core';
import { IconUpload } from '@tabler/icons-react';
import { MassUploadPanel } from './MassUploadPanel';
import { useUploadModal } from './upload-modal-context';
import { useUploadStats } from '@/lib/upload/use-upload-stats';

import type { JSX } from "react";

export function UploadModal(): JSX.Element {
  const { isOpen, close } = useUploadModal();
  const { total, working, errors, ready } = useUploadStats();

  return (
    <Modal
      opened={isOpen}
      onClose={close}
      size={900}
      fullScreen={false}
      centered
      withCloseButton
      padding="lg"
      radius="md"
      title={
        <Group gap={10} align="center">
          <IconUpload size={18} />
          <Text fw={600} size="lg" style={{ fontFamily: "'Fraunces', Georgia, serif" }}>
            Mass upload
          </Text>
          {total > 0 && (
            <Text size="sm" c="dimmed">
              · {working} working · {ready} ready{errors > 0 ? ` · ${errors} errors` : ''}
            </Text>
          )}
        </Group>
      }
      styles={{
        body: { background: '#fbf7f2' },
        header: { background: '#fbf7f2', borderBottom: '1px solid #ece4d8' },
        content: { maxWidth: '95vw' },
      }}
    >
      <MassUploadPanel hideTitle />
    </Modal>
  );
}
